export function initVehicleStage() {
    return [...document.querySelectorAll('.b-vehicle-stage:not(.-initialized)')].map(el => new VehicleStage(el));
}

export class VehicleStage {
    constructor(element) {
        this.element = element;
        this.element.classList.add('-initialized');

        this.images = this.element.querySelectorAll('.b-vehicle-stage__image img');

        this.prev = this.element.querySelector('.b-vehicle-stage__image-navigation.-prev');
        this.next = this.element.querySelector('.b-vehicle-stage__image-navigation.-next');

        this.pagination = this.element.querySelector('.b-vehicle-stage__image-pagination');

        this.init();
    }

    init() {
        this.currentIndex = 0;

        if (this.images.length > 0) {
            this.images[this.currentIndex].classList.add('-active');
        }

        // Update navigation state based on total images
        const updateNavigationState = () => {
            // Disable prev button if at first image
            if (this.currentIndex === 0) {
                this.prev.classList.remove('-active');
                this.prev.setAttribute('disabled', 'true');
            } else {
                this.prev.classList.add('-active');
                this.prev.removeAttribute('disabled');
            }

            // Disable next button if at last image
            if (this.currentIndex === this.images.length - 1) {
                this.next.classList.remove('-active');
                this.next.setAttribute('disabled', 'true');
            } else {
                this.next.classList.add('-active');
                this.next.removeAttribute('disabled');
            }

            // Update pagination if exists
            if (this.pagination) {
                this.pagination.innerHTML = `${this.currentIndex + 1} / ${this.images.length}`;
            }
        };

        // Initial navigation state
        if (this.images.length <= 1) {
            this.prev.classList.remove('-active');
            this.next.classList.remove('-active');
            return;
        }

        // Add event listeners for navigation
        this.prev.addEventListener('click', () => {
            if (this.currentIndex > 0) {
                this.images[this.currentIndex].classList.remove('-active');
                this.currentIndex--;
                this.images[this.currentIndex].classList.add('-active');
                updateNavigationState();
            }
        });

        this.next.addEventListener('click', () => {
            if (this.currentIndex < this.images.length - 1) {
                this.images[this.currentIndex].classList.remove('-active');
                this.currentIndex++;
                this.images[this.currentIndex].classList.add('-active');
                updateNavigationState();
            }
        });

        // Set initial navigation state
        updateNavigationState();
    }
}